module.exports = __webpack_public_path__ + "backstop.cba48e8a649979a2eb5f93812cd75f9d.svg";